var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header"},[_c('the-navigation-drawer',{attrs:{"nav-items":_vm.navItems,"navigation-title":"Navigation"}}),_vm._v(" "),_c('the-navigation-bar',{attrs:{"nav-items":_vm.navItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }